import { Linkedin } from "lucide-react";
import { Reveal, SectionTag } from "@/components/primitives";
import { useLanguage } from "@/hooks/use-language";

const INITIALS = ["CEO", "CTO", "CPO"];

export const Leadership = () => {
  const { t } = useLanguage();
  return (
  <section id="team" className="py-24 lg:py-32 border-b border-border" data-testid="leadership-section">
    <div className="max-w-7xl mx-auto px-6 lg:px-10">
      <Reveal>
        <SectionTag index="07" label={t.team.tag} />
        <h2 className="font-display font-bold tracking-tight text-4xl sm:text-5xl max-w-3xl">
          {t.team.h2}
        </h2>
        <p className="mt-6 max-w-xl text-base md:text-lg text-muted-foreground">
          {t.team.sub}
        </p>
      </Reveal>

      <div className="mt-16 grid md:grid-cols-3 border border-border">
        {t.team.members.map((member, i) => (
          <Reveal key={member.role} delay={i * 0.12} className={`${i > 0 ? "border-t md:border-t-0 md:border-l" : ""} border-border`}>
            <div className="group p-10 h-full hover:bg-secondary/60 transition-colors duration-500" data-testid={`leader-card-${i}`}>
              <div className="w-20 h-20 rounded-sm bg-gradient-to-br from-teal-500 to-green-500 flex items-center justify-center group-hover:scale-105 transition-transform duration-500">
                <span className="font-display font-black text-xl text-[#0a0a0a]">{INITIALS[i]}</span>
              </div>
              <h3 className="mt-8 font-display font-bold text-lg">{member.role}</h3>
              <p className="mt-4 text-sm leading-relaxed text-muted-foreground">{member.bio}</p>
              <div className="mt-6 flex items-center gap-2 text-muted-foreground/50 group-hover:text-teal-600 dark:group-hover:text-teal-400 transition-colors duration-300">
                <Linkedin size={16} />
                <span className="text-xs tracking-[0.2em] uppercase">{t.team.onRequest}</span>
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
  );
};
